export const finiteAudioValue = (value: number, fallback = 0): number =>
  Number.isFinite(value) ? value : fallback;

export const normalizedAudioValue = (value: number): number =>
  Math.max(0, Math.min(1, finiteAudioValue(value)));

export type ImpactTriggerSample = {
  impact: number;
  trigger: boolean;
};

export const createImpactTriggerGate = (): ((value: number) => ImpactTriggerSample) => {
  let armed = true;
  return (value) => {
    const impact = normalizedAudioValue(value);
    const trigger = armed && impact >= 0.2;
    if (trigger) {
      armed = false;
    } else if (impact < 0.08) {
      armed = true;
    }
    return { impact, trigger };
  };
};
